import React from "react";
import { Link, useLocation } from "react-router-dom";
import dignostic from "../../assets/img/diagnostic-1.svg";
import shield from "../../assets/img/Group 27229.svg";
import recentReports from "../../assets/img/indexing-pages-1.svg";
import health from "../../assets/img/Group 27228.svg";
import generateReport from "../../assets/img/generate-report-1.svg";
import firstAid from "../../assets/img/Group 27227.svg";
import { useHistory } from 'react-router-dom';

import "./PillNav.scss";

const PillNav = ({ state }) => {
  console.log(state)
  const location = useLocation();
  const activeNav = location.pathname.split("/")[2];
  const history = useHistory();
  console.log(state)

  const pillNavList = [
    // {
    //   name: "tele-console",
    //   icon: dignostic,
    //   path: "/doctor/tele-console",
    // },
    {
      name: "Prescription",
      icon: shield,
      path: "/doctor/Prescription",
    },
    {
      name: "Reports",
      icon: recentReports,
      path: "/doctor/Reports",
    },
    {
      name: "Timeline",
      icon: health,
      path: "/doctor/Timeline",
    },
    {
      name: "Dicom",
      icon: generateReport,
      path: "/doctor/Dicom",
    },
    {
      name: "Wellness Report",
      icon: firstAid,
      path: "/doctor/Wellness",
    },
  ];
  // d-none d-xl-flex btn btn__primary btn__rounded ml-30
  return (
    <div class="pill-nav-container" style={{ padding: "5px" }}>
      <img src="/img/left-arrow-gray.svg" alt="left navigation" onClick={() => history.goBack()} />
      {pillNavList.map((navItem, i) => (
        <Link
          key={i}
          to={{ pathname: navItem.path, state: state }}
          title={navItem.name}
          class={`pill-nav${navItem.name === activeNav ? "-active" : ""}`}
        >
          <img src={navItem.icon} alt={navItem.name} />
        </Link>
      ))}
      <img src="/img/Expand - icon-5.svg" alt="right arrow" />
    </div>
  );
};

export default PillNav;
